/**
 * Validate a `callbackUrl` query param against an origin to prevent
 * open-redirect attacks (CxOne HIGH finding addressed in PR #3177).
 *
 * Rules:
 *  - Empty / missing → '/'
 *  - Same-origin absolute URL or relative path → returns pathname + search + hash
 *  - Different-origin URL or malformed input → '/'
 *
 * Pure function — safe to import from both client and server, no `window` access.
 */
export function getSafeCallbackUrl(raw: string | null | undefined, origin: string): string {
  if (!raw) return '/'

  try {
    const url = new URL(raw, origin)
    if (url.origin !== origin) return '/'
    return url.pathname + url.search + url.hash
  } catch {
    return '/'
  }
}
